import {
  VERIFY_OTP_IN_PROGRESS,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILED,
  VERIFY_EMAIL_IN_PROGRESS,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILED,
  REFRESH_EXISTING_USER,
  LOG_USER_OUT,
} from "../../../constants/store";

const initialState = {
  data: false,
  message: "",
  status: true,
  currentUser: false,
  loading: false,
  // userID: 0,
  userToken: "",
  loggedIn: false,
  error: false
};

function verifyUserReducer(state = initialState, action) {
  // Log action.payload: Payload values should be the response data from API call
  switch (action.type) {
    case VERIFY_EMAIL_IN_PROGRESS:
      return {
        ...state,
        status: true,
      };

    case VERIFY_EMAIL_SUCCESS:
      localStorage.setItem('userToken', action.payload.status == 200 ? action.payload.data.token : "" ); 
      return {
        ...state,
        status: true,
        currentUser: action.payload.status == 200 ? true : false,
        userExists: action.payload.status == 204 ? false : true,
        userToken: action.payload.status == 200 ? action.payload.data.token : ""
      };

    case VERIFY_EMAIL_FAILED:
      return {
        ...state,
        status: false,
      };

    case VERIFY_OTP_IN_PROGRESS:
      return {
        ...state,
        status: true,
      };

    case VERIFY_OTP_SUCCESS:
		if (action.payload.status==200) {
			// localStorage.setItem('userToken', action.payload.data.token);
			// localStorage.setItem('userID', action.payload.data.userID);
			return {
				...state,
				status: true,
				currentUser: true,
				// userID: action.payload.data.userID,
        // userToken: action.payload.data.token,
        loggedIn: true,
			};
		} else {
			return {
				...state,
				status: false,
				currentUser: false,
				// userID: 0,
        userToken: "",
        loggedIn: false,
        error: true
			};
		}

    case VERIFY_OTP_FAILED:
      localStorage.removeItem('userToken');
      localStorage.removeItem('userID');
      return {
        ...state,
        status: false,
        // userID: 0,
        userToken: "",
        loggedIn: false,
        error: true
      };

    case REFRESH_EXISTING_USER:
      return{
        userExists: true,
      };

    case LOG_USER_OUT:
      localStorage.removeItem('userToken');
      localStorage.removeItem('userID');
      return {
        ...state,
        status: false,
        // userID: 0,
        userToken: "",
        loggedIn: false,
      };

    default:
      return state;
  }
}

export default verifyUserReducer;
